export const RecordStore = {
  his_list: [],
  noData: false,
  page_no: 0,
  has_next_page: 1,
  showMoreLoading: false,
};
